import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createClinicUser = createAsyncThunk(
  "clinicUser/createClinicUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/clinicUser/createClinicUser", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const getClinicUserByIdSlice = createAsyncThunk(
  "clinicUser/getClinicUserById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/clinicUser/getClinicUserById", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateClinicUser = createAsyncThunk(
  "clinicUser/updateClinicUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/clinicUser/updateClinicUser", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const deleteClinicUser = createAsyncThunk(
  "clinicUser/deleteClinicUser",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/clinicUser/deleteClinicUser", data, {
        headers: {
          "Content-Type": "application/json",
          token: data.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const initialState = {
  loading: false,
  clinicUser: [],
  error: null,
  isLoading: false,
  createclinicUserSuccessMessage: null,
  createclinicUserErrorMessage: null,
  updateclinicUserSuccessMessage: null,
  updateclinicUserErrorMessage: null,
  deleteclinicUserSuccessMessage: null,
  deleteclinicUserErrorMessage: null,
  searchMessage: null,
};

const clinicUserSlice = createSlice({
  name: "clinicUser",
  initialState,
  reducers: {
    resetCreateMessages: (state) => {
      state.createclinicUserSuccessMessage = null;
      state.createclinicUserErrorMessage = null;
    },
    resetUpdateMessages: (state) => {
      state.updateclinicUserSuccessMessage = null;
      state.updateclinicUserErrorMessage = null;
    },
    resetDeleteMessages: (state) => {
      state.deleteclinicUserSuccessMessage = null;
      state.deleteclinicUserErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createClinicUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createClinicUser.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.createclinicUserErrorMessage = action.payload.result.message;
        } else {
          state.createclinicUserSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(createClinicUser.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(updateClinicUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateClinicUser.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.updateclinicUserSuccessMessage = action.payload.result.message;
        } else {
          state.updateclinicUserErrorMessage = action.payload.result.message;
        }
      })
      .addCase(updateClinicUser.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deleteClinicUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteClinicUser.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === true) {
          state.deleteclinicUserSuccessMessage = action.payload.result.message;
        } else {
          state.deleteclinicUserErrorMessage = action.payload.result.message;
        }
      })
      .addCase(deleteClinicUser.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getClinicUserByIdSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getClinicUserByIdSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success) {
          state.clinicUser = action.payload.result.list;
        } else {
          state.errorMessage = action.payload.result.message;
        }
      })
      .addCase(getClinicUserByIdSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.payload || "Failed to fetch clinicUser Data";
      });
  },
});
export const { resetCreateMessages, resetUpdateMessages, resetDeleteMessages } =
  clinicUserSlice.actions;
export default clinicUserSlice.reducer;
